/**
 * Considers an element visible if it is not hidden by CSS, has height, and some part of its bounding box overlaps the viewport.
 */
export default function isVisible(el: Element) {
  if (!el) return;

  const style = window.getComputedStyle(el);
  if (style.display === 'none') return false;
  if (style.visibility === 'hidden') return false;
  if (style.opacity === '0') return false;

  const { height, top, bottom, left, right } = el.getBoundingClientRect();

  return (
    height > 0 &&
    top < window.innerHeight &&
    bottom > 0 &&
    left < window.innerWidth &&
    right > 0
  );
}
